import { GetTenantStripeConnectQuery } from "~/gql/queries/tenantStripeConnect.generated";

export const tenantStripeConnectEndpoints = {
	GetTenantStripeConnect: {
		providesTags: ["TenantStripeConnect"] as AddTagTypes,
		transformResponse: (res: GetTenantStripeConnectQuery) => res
	},
	CreateTenantStripeConnectedAccount: {
		invalidatesTags: ["TenantStripeConnect"] as AddTagTypes
	},
	// Accepted exception: minting an Account Session token mutates no tenant state, so it invalidates nothing.
	CreateTenantStripeAccountSession: {},
	RefreshTenantStripeTaxReadiness: {
		invalidatesTags: ["TenantStripeConnect"] as AddTagTypes
	}
};
